import styled from 'styled-components';

const StyledFadeContainer = styled.div<{ $animated?: boolean }>`
	position: relative;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}

	@property --topFade {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}

	@property --bottomFade {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}

	-webkit-mask-image: linear-gradient(
		to bottom,
		transparent 0,
		black var(--topFade),
		black calc(100% - var(--bottomFade)),
		transparent 100%
	);
	mask-image: linear-gradient(
		to bottom,
		transparent 0,
		black var(--topFade),
		black calc(100% - var(--bottomFade)),
		transparent 100%
	);

	-webkit-mask-repeat: no-repeat;
	mask-repeat: no-repeat;

	-webkit-mask-size: 100% 100%;
	mask-size: 100% 100%;

	transition: ${({ $animated }) =>
		$animated
			? `
		--topFade 300ms ease,
		--bottomFade 300ms ease
	`
			: 'none'};
`;

export { StyledFadeContainer };
